import type { AdvLine } from './adv'

// 初見監査 2回目の直し (2026-11-04 作者が「直す」と答えた9問)。
//   ship = 配布版の既定 (11-04 作者が選んだ6問)。 開発版 ?advFix2=old で前の文・a|b で比較した2案に戻せる。
//   a = 誤読だけ防ぐ小さい案・b = 踏み込む案。 記録 = docs/research/2026-11-04-blind-audit-fix-round2.md・round3.md。
//   声の行は声の差し替え (adv_voice_v2) の後の文で当てる。
export type AdvFix2Variant = 'now' | 'a' | 'b' | 'ship'
type Edit = { kind: AdvLine['kind']; from: string; to?: string; after?: AdvLine[] }

const say = (text: string): AdvLine => ({ kind: 'lunaire', speech: 'inner', text })
const nar = (text: string): AdvLine => ({ kind: 'narration', text })

const RAKU = '……これで、楽になれた。'

// s07 の地の文の「獣」を全部「鶏」へ (02・06 の獣とも分かれる)。 最初の行だけ案ごとに違う。
const S07_REST: readonly Edit[] = [
  { kind: 'narration', from: '獣は鐘のほうへ向き直り、また最初から数え始めた。', to: '鶏は鐘のほうへ向き直り、また最初から数え始めた。' },
  { kind: 'narration', from: '獣が翼を広げ、こちらへ飛びかかった。', to: '鶏が翼を広げ、こちらへ飛びかかった。' },
  { kind: 'narration', from: '鐘の下に、獣が倒れていた。', to: '鐘の下に、鶏が倒れていた。' },
  { kind: 'narration', from: '倒れたまま、獣はまだ、小さく数えていた。', to: '倒れたまま、鶏はまだ、小さく数えていた。' },
  { kind: 'narration', from: '獣の腰から、綱をほどいた。', to: '鶏の腰から、綱をほどいた。' },
  { kind: 'narration', from: 'ほどけた綱を、獣の腰に巻き直した。', to: 'ほどけた綱を、鶏の腰に巻き直した。' },
  { kind: 'narration', from: '獣は、また最初から数え始めた。', to: '鶏は、また最初から数え始めた。' },
]

const S02_B: Edit = { kind: 'narration', from: '階段の下に、獣が倒れていた。', after: [nar('顔から外れた王冠が、割れて、床に転がっていた。')] }
// s0910 b: 09 の顔は絵では刃の面。 10 の文も絵 (長い刃) に合わせ、「同じ形の、レイピア」の手がかりを柄の形へ移す。
const S0910_B: readonly Edit[] = [
  { kind: 'narration', from: '両手に、刃を一振りずつ。目には、黒い布。', to: '両手に、刃を一振りずつ。顔は、刃の面に覆われていた。' },
  { kind: 'narration', from: '女は、レイピアを、くるりと回した。', to: '女は、刃を、くるりと回した。' },
  { kind: 'narration', from: '倒れた女のそばに、レイピアが落ちていた。', to: '倒れた女のそばに、刃が落ちていた。' },
  { kind: 'narration', from: '同じ形の、レイピア。', to: '柄の形が、手の中のレイピアと、同じだった。' },
  { kind: 'narration', from: '女のそばにレイピアが落ちていた。', to: '女のそばに刃が落ちていた。' },
  { kind: 'narration', from: '同じ形のレイピア。', to: '柄の形が、手の中のレイピアと同じだった。' },
  { kind: 'narration', from: '落ちていたレイピアにも、触れなかった。', to: '落ちていた刃にも、触れなかった。' },
]
// s_accept b: 01 で「斬るしかない」をすぐ呑まない。 06 で声の嘘が分かった後の「楽に」も、 声に返された所で疑う。
const S_ACCEPT_B: readonly Edit[] = [
  { kind: 'narration', from: '指が、すぐには閉じなかった。', after: [say('……ほんとうに、それしか、ないの？')] },
  { kind: 'voice', from: '——……うん。楽に、なれたよ。', after: [say('……ほんとうに？')] },
]
// s_loop b: 10 の先代から灯へ流れる光を、 06 の獣と同じだと見せてから気づく (灯の役目は言わない)。
const S_LOOP_B: Edit = { kind: 'narration', from: '見つめた。', after: [nar('倒れた女から、細い光が、灯へ流れていった。'), nar('あの獣の時と、同じ光だった。')] }

const EDITS_A: readonly Edit[] = [
  // s02: 戦う前は王冠が顔にはまっている。落ちた事を1行で見せる (選択2の「床に転がった王冠」の前置き)。
  { kind: 'narration', from: '階段の下に、獣が倒れていた。', after: [nar('王冠が、床に転がっていた。')] },
  // s07: 初めて出る所で一度だけ、名札「鶏」と地の文「獣」をつなぐ。
  { kind: 'narration', from: '吊られた鐘の下に、獣がうずくまっていた。', to: '吊られた鐘の下に、鶏のような獣がうずくまっていた。' },
  // s0910: 10 のレイピアは文を残し、絵を描き直す側で合わせる。
  S0910_B[0]!,
  // s5sec: 物語の文から操作の秒数を外す。
  { kind: 'narration', from: '5秒が、過ぎた。', to: '選べないまま、時が過ぎた。' },
  S_ACCEPT_B[0]!,
  // s_loop: 確信を問いに下げる。
  { kind: 'lunaire', from: 'あれが、続かせていた。', to: 'あれが、続かせていた……？' },
  // s_lord: 主が誰かは決めない。主人公も知らないと分かるようにする。
  { kind: 'boss', from: '主、いる。', after: [say('……主って、誰のことだろう。')] },
  // sraku: 誰が楽になったかを足す。3か所とも同じ形のまま。
  { kind: 'lunaire', from: RAKU, to: '……これで、あなたは、楽になれた。' },
]

const EDITS_B: readonly Edit[] = [
  S02_B,
  { kind: 'narration', from: '吊られた鐘の下に、獣がうずくまっていた。', to: '吊られた鐘の下に、大きな鶏がうずくまっていた。' },
  ...S07_REST,
  ...S0910_B,
  // s5sec b: 主語を舞台へ。考えていた時間を「選んだ」扱いにしない。
  { kind: 'narration', from: '5秒が、過ぎた。', to: '舞台は、もう待たなかった。' },
  ...S_ACCEPT_B,
  S_LOOP_B,
  // s_lord b: 主は月喰いの王ではない、と獣に言わせる (主が誰かは言わない)。
  { kind: 'boss', from: '主、いる。', after: [{ kind: 'lunaire', speech: 'spoken', text: '主って、王さまのこと？' }, { kind: 'boss', name: '獣', text: '……ちがう。' }] },
]

// 配布版 (11-04 作者)：s02=b・s07=a を土台に「獣」を「鶏」へ・s0910=b・s_accept=b・s_loop=b・s_lord=b を土台に「月喰いの王」を問う形へ。
//   s5sec・sraku・p_retry は入れない (5秒の文と「楽になれた」は今のまま・p_retry は製品版に入れない機能なので触らない)。
const EDITS_SHIP: readonly Edit[] = [
  S02_B,
  // 作者「A案にして、獣のところは鶏にしてください。」
  { kind: 'narration', from: '吊られた鐘の下に、獣がうずくまっていた。', to: '吊られた鐘の下に、鶏がうずくまっていた。' },
  ...S07_REST,
  ...S0910_B,
  ...S_ACCEPT_B,
  S_LOOP_B,
  // 作者「王様のことって聞くと、獣にとっては王様になってしまいます。…月食いの王かどうか聞かないといけない」。
  //   呼び名は序幕で声が言う「月喰いの王」(主人公はもう知っている)。 主は月喰いの王ではない、 主が誰かは言わない。
  { kind: 'boss', from: '主、いる。', after: [{ kind: 'lunaire', speech: 'spoken', text: '主って、月喰いの王のこと？' }, { kind: 'boss', name: '獣', text: '……ちがう。' }] },
]

// b の sraku：3か所の言い方を相手ごとに変える (02・04・05)。
const RAKU_B = ['……これで、この子は、楽になれた。', '……これで、あなたは、楽になれた。', '……これで、この人は、楽になれた。'] as const
const RAKU_SCENE_B: Readonly<Record<string, string>> = { 'dream-hound': RAKU_B[0], bride: RAKU_B[1], 'the-executioner': RAKU_B[2] }

let variant: AdvFix2Variant = 'ship'
export function setAdvFix2(v: string | null | undefined): AdvFix2Variant {
  return (variant = v === 'old' ? 'now' : v === 'a' || v === 'b' ? v : 'ship')
}
export function advFix2(): AdvFix2Variant { return variant }

// sraku 3回目 (11-04 作者「楽になれたっていうか、…苦しんでいるわけではないから、表現ちょっと考え直したい」→ 11-04 19:40 の答え b)。
//   配布版の既定 = b「救ってあげられた」。 開発版 ?raku=old で前の「楽になれた」、 ?raku=a|c で他の案。
//   06 (覚醒獣) の言いさしとそれを受ける声の返事・07 (鶏) の途切れも同じ頭に合わせる (崩れ方の順番は残す)。
//   b の時は 02 前の声と先代の部屋の「楽にしてあげる」も「救ってあげる」へそろえる (RAKU_ALIGN・?rakuAlign=off で戻る)。
//   旧い「残る」台本 (?stayEnding=old) の「楽にしてあげる」は配布版に出ないので触らない。
export type RakuVariant = 'now' | 'a' | 'b' | 'c'
export const RAKU_PLANS: Readonly<Record<Exclude<RakuVariant, 'now'>, { full: string; cut06: string; voice06: string; cut07: string }>> = {
  a: { full: '……これで、終わらせてあげられた。', cut06: 'これで、終わらせて——', voice06: '——……うん。終わらせて、あげられたよ。', cut07: '……これで、終わらせて——' },
  b: { full: '……これで、救ってあげられた。', cut06: 'これで、救って——', voice06: '——……うん。救って、あげられたよ。', cut07: '……これで、救って——' },
  c: { full: '……これで、やっと、終われた。', cut06: 'これで、やっと——', voice06: '——……うん。やっと、終われたよ。', cut07: '……これで、やっと——' },
}
const VOICE06 = '——……うん。楽に、なれたよ。'
let raku: RakuVariant = 'b'
export function setRaku(v: string | null | undefined): RakuVariant {
  return (raku = v === 'old' ? 'now' : v === 'a' || v === 'c' ? v : 'b')
}
export function rakuVariant(): RakuVariant { return raku }

// b の時に「楽にしてあげる」をそろえる行 (声は配布版の声 v2 の文)。
const RAKU_ALIGN: Readonly<Record<string, string>> = {
  '待ちくたびれちゃったんだね。じゃあ、あなたが楽にしてあげて。': '待ちくたびれちゃったんだね。じゃあ、あなたが救ってあげて。',
  'みんな、楽にしてあげたんだよね。': 'みんな、救ってあげたんだよね。',
  'うん。みんな、楽にしてあげた。': 'うん。みんな、救ってあげた。',
  '私もね、そう思ってた。楽にしてあげてるんだって。': '私もね、そう思ってた。救ってあげてるんだって。',
}
let rakuAlign = true
export function setRakuAlign(v: string | null | undefined): boolean { return (rakuAlign = v !== 'off') }

// 4回目 (11-04 作者メモ「毎回同じ言い回しが正しいのかは少し疑問」)。 b の時だけ効く。 既定 = 2 (11-04 作者 vary=2)。
//   開発版 ?rakuVary=1 で 1、 ?rakuVary=off で 3か所とも同じ形 (前の版)。
//   1 = 救の頭は残し、 重ねるごとに数える形へ (05 の「一つずつ、終わらせてきた」・07 の「終わらせた数」へつながる)。
//   2 = 相手に返す言葉へ (04 は「待たせて」・05 は「読み上げ」を受ける)。 02 はどちらも b のまま。
//   記録 = docs/research/2026-11-04-blind-audit-fix-round4.md。
export const RAKU_VARY: Readonly<Record<'1' | '2', Readonly<Record<string, string>>>> = {
  1: { bride: '……これで、この人も、救えた。', 'the-executioner': '……また、ひとり、救えた。' },
  2: { bride: '……これで、もう、待たなくていい。', 'the-executioner': '……これで、もう、読まなくていい。' },
}
let rakuVary: '1' | '2' | null = '2'
export function setRakuVary(v: string | null | undefined): '1' | '2' | null { return (rakuVary = v === 'off' ? null : v === '1' ? '1' : '2') }

function applyRaku(line: AdvLine, scene: string): AdvLine {
  if (raku === 'now') return line
  const p = RAKU_PLANS[raku]
  if (line.kind === 'voice' && line.text === VOICE06) return { ...line, text: p.voice06 }
  if (raku === 'b' && rakuAlign && (line.kind === 'voice' || line.kind === 'boss' || line.kind === 'lunaire') && RAKU_ALIGN[line.text]) return { ...line, text: RAKU_ALIGN[line.text] }
  if (line.kind !== 'lunaire') return line
  if (line.text === RAKU) return { ...line, text: (raku === 'b' && rakuVary && RAKU_VARY[rakuVary][scene]) || p.full }
  if (line.text === 'これで、楽に——') return { ...line, text: p.cut06 }
  if (line.text === '……これで、楽に——') return { ...line, text: p.cut07 }
  return line
}

// s5sec 3回目 (11-04 作者「時間で選択肢を強制で選ばされるっていう機能はなくしてもいいかなと思っています。」)。
//   配布版の既定 = 外す (11-04 19:40 の答え off_drop「外す。終幕その4もしまう」)。 先代のあとの「残る / 出る」は秒の表示も消え、 選ぶまで待つ。
//   時間切れでしか行けない終幕その4 (loop2・呑まれる) には行けない (台本と絵は残す)。 開発版 ?choiceTimer=on で前の5秒。
//   記録 = docs/research/2026-11-04-blind-audit-fix-round3.md・round4.md。
let choiceTimer = false
export function setChoiceTimer(v: string | null | undefined): boolean {
  return (choiceTimer = v === 'on')
}
export function choiceTimerOn(): boolean { return choiceTimer }

// p_retry: 負け画面のボタンと、一戦だけモードで勝った後の出口の呼び方をそろえる。
//   a = 「再演」へそろえる (勝った後の感想欄・案内も)・b = 「もう一度戦う」へそろえる (負け画面のボタンも)。 既定 (ship) は今のまま。
export function retryLabels(): { button: string; buttonWidth: number; close: string; hint: string } {
  if (variant === 'b') return { button: '▶  もう一度戦う', buttonWidth: 230, close: 'もう一度戦う', hint: 'もう一度戦うには、下の『もう一度戦う』（パッドは ✕）' }
  if (variant === 'a') return { button: '▶  再 演', buttonWidth: 150, close: '再演', hint: '再演するには、下の『再演』（パッドは ✕）' }
  return { button: '▶  再 演', buttonWidth: 150, close: 'もう一度戦う', hint: 'もう一度戦うには、下の『もう一度戦う』（パッドは ✕）' }
}

export function advFix2Active(): boolean { return variant !== 'now' || raku !== 'now' }

// sceneId = 'interlude:dream-hound' など。b の sraku の出し分けに使う。
export function applyAdvFix2Lines(lines: AdvLine[], sceneId = ''): AdvLine[] {
  if (!advFix2Active()) return lines
  const edits = variant === 'a' ? EDITS_A : variant === 'b' ? EDITS_B : variant === 'ship' ? EDITS_SHIP : []
  // raku は直し (声の行に当てる s_accept など) の後に当てる。
  return lines.flatMap(line => {
    if (raku === 'now' && variant === 'b' && line.kind === 'lunaire' && line.text === RAKU) {
      const to = RAKU_SCENE_B[sceneId.split(':')[1] ?? '']
      return [to ? { ...line, text: to } : line]
    }
    if (!('text' in line)) return [line]
    const e = edits.find(x => x.kind === line.kind && x.from === line.text)
    if (!e) return [line]
    return [e.to ? { ...line, text: e.to } as AdvLine : line, ...(e.after ?? [])]
  }).map(l => applyRaku(l, sceneId.split(':')[1] ?? ''))
}
